import { render, staticRenderFns } from "./ReadEditDatePicker.vue?vue&type=template&id=01c88ba3&scoped=true&"
import script from "./ReadEditDatePicker.vue?vue&type=script&lang=ts&"
export * from "./ReadEditDatePicker.vue?vue&type=script&lang=ts&"
import style0 from "./ReadEditDatePicker.vue?vue&type=style&index=0&id=01c88ba3&scoped=true&lang=scss&"
import style1 from "./ReadEditDatePicker.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c88ba3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDatePicker,VMenu,VSpacer,VTextField})
